import Index from '../../pages/sakura/portrait/index';
import Help from '../../pages/sakura/portrait/help';
import Test from '../../pages/sakura/portrait/test.vue'

const base = 'portrait';

const routes = [{
        path: `/${base}/index`,
        name: `${base}-index`,
        component: Index
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index
    },
    {
        path: `/${base}/help*`,
        name: `${base}-help`,
        component: Help
    },
    {
        path: `/${base}/test*`,
        name: `${base}-test`,
        component: Test
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/sakura/portrait.js